export default __webpack_public_path__ + "static/media/connected_icon_bold.c4e125cb.svg";